import { QuickWidgetsState, QuickWidgetTypes } from "../reducer/user.reducer";

export const WIDGET_LEFT_MARGIN = 60
export const QUICK_WIDGET_MIN_TOP_OFFSET = 16
export const QUICK_WIDGET_BOTTOM_MARGIN = 8

export type QuickWidgetBounds = {
    left: number
    top: number
    width: number
    height: number
}

export type QuickWidgetPositionInput = {
    left?: number
    top?: number
    bottom?: number
}

export const resolveQuickWidgetTop = (
    position: QuickWidgetPositionInput | undefined,
    height: number,
    viewportHeight = window.innerHeight,
): number => {
    if (position?.top != null) {
        return position.top
    }
    if (position?.bottom != null) {
        return viewportHeight - position.bottom - height
    }
    return viewportHeight - height - QUICK_WIDGET_BOTTOM_MARGIN
}

export const clampQuickWidgetBounds = (
    bounds: QuickWidgetBounds,
    viewportWidth = window.innerWidth,
    viewportHeight = window.innerHeight,
): QuickWidgetBounds => {
    let { left, top, width, height } = bounds

    width = Math.max(0, Math.min(width, viewportWidth))
    height = Math.max(0, Math.min(height, viewportHeight - QUICK_WIDGET_MIN_TOP_OFFSET))

    left = Math.max(0, Math.min(left, viewportWidth - width))
    top = Math.max(QUICK_WIDGET_MIN_TOP_OFFSET, Math.min(top, viewportHeight - height))

    return { left, top, width, height }
}

export const getQuickWidgetConfigs = (toggleWidget: QuickWidgetTypes, quickWidgets: QuickWidgetsState, toggle = false): QuickWidgetsState => {

    const horizontalSortedWidgets = Object.keys(quickWidgets).sort((a, b) => quickWidgets[a as QuickWidgetTypes]!.position!.left - quickWidgets[b as QuickWidgetTypes]!.position!.left) as QuickWidgetTypes[];
    let widgetOrder = Object.keys(quickWidgets).sort((a, b) => quickWidgets[a as QuickWidgetTypes]!.order - quickWidgets[b as QuickWidgetTypes]!.order) as QuickWidgetTypes[];

    if (!widgetOrder.includes(toggleWidget)) {
        widgetOrder.push(toggleWidget)
    } else {
        widgetOrder = widgetOrder.filter(w => w !== toggleWidget).concat(toggleWidget)
    }
    const newConfig: QuickWidgetsState = {}

    widgetOrder.forEach((widgetType, i) => {
        let height = 350;
        let width = 450;
        let title = "";
        let left = WIDGET_LEFT_MARGIN;
        let top = window.innerHeight - height - QUICK_WIDGET_BOTTOM_MARGIN;

        switch (widgetType) {
            case QuickWidgetTypes.MARKET_DEPTH:
                title = "Market Depth";
                break;
            case QuickWidgetTypes.ORDER:
                width = 600;
                title = "Orders";
                break;
            case QuickWidgetTypes.POSITION:
                width = 600;
                title = "Positions";
                break;
            case QuickWidgetTypes.QUICK_TRADE:
                width = 520;
                height = 165;
                title = "Quick Trade";
                top = window.innerHeight - height - QUICK_WIDGET_BOTTOM_MARGIN;
                break;
            default:
                title = widgetType;
        }

        if (widgetOrder.length > 1) {
            horizontalSortedWidgets.forEach((w) => {
                const widget = quickWidgets[w];

                if (widget!.position!.left < left + width + 8) {
                    left = widget!.position!.left + widget!.dimensions.width + 8
                }
            })

            if (left + width > window.innerWidth) {
                const firstWidget = quickWidgets[horizontalSortedWidgets[0]];
                left = WIDGET_LEFT_MARGIN;
                top = resolveQuickWidgetTop(firstWidget!.position as QuickWidgetPositionInput, firstWidget!.dimensions.height)
                    + firstWidget!.dimensions.height + 8
            }
        }

        const existing = quickWidgets[widgetType];
        const isToggled = toggle && toggleWidget === widgetType;

        newConfig[widgetType] = {
            enabled: existing ? (isToggled ? !existing.enabled : existing.enabled) : true,
            visible: true,
            order: i + 1,
            title,
            dimensions: existing ? existing.dimensions : { width , height },
            position: existing?.position
                ? {
                    left: existing.position.left,
                    top: resolveQuickWidgetTop(existing.position as QuickWidgetPositionInput, existing.dimensions.height),
                }
                : { left, top },
            settings: existing?.settings ?? {},
        };
    });

    return newConfig
}
